import React from 'react'

export function getAreaDisplayFromMetresSquared(area: number) {
  if (area < 10000) {
    return <React.Fragment>{area.toLocaleString()} m<sup>2</sup></React.Fragment>
  } else {
    return (
      <React.Fragment>
        {(area / 10000).toLocaleString(undefined, { maximumFractionDigits: 2 })} ha
      </React.Fragment>
    )
  }
}